var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_admin_Tax_list_title"),
      pad: "0",
      filterable: "",
    },
    on: {
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(filter)
                },
                update: function (prop, value, selected) {
                  if (prop == "department") {
                    _vm.curDept = value
                  } //触发岗位更新下拉
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "nav-actions",
        fn: function () {
          return [
            _vm.hasBtn("import-admin-tax-form")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "white--text primary mr-2",
                    attrs: { icon: "" },
                    on: {
                      click: function ($event) {
                        _vm.files = null
                        _vm.selected = []
                        _vm.selectWillStaff = null
                        _vm.showUpload = true
                      },
                    },
                  },
                  [
                    _c("svg-icon", {
                      attrs: { size: "24", fill: "white", iconClass: "upload" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-card",
              {
                staticClass: "transparent d-flex flex-row rounded-lg",
                attrs: { elevation: "0" },
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "fill-height white rounded-lg pa-0",
                    style: {
                      minHeight:
                        _vm.$vuetify.breakpoint.height - 238 + 42 - 48 + "px",
                    },
                    attrs: { elevation: "0", width: "280" },
                  },
                  [
                    _vm.allStaff.length == 0 && !_vm.staff_Loading
                      ? _c("noContent")
                      : _vm._e(),
                    _vm.staff_Loading
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "text-center d-flex align-center justify-center",
                            style: {
                              minHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                48 +
                                "px",
                            },
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                color: "primary",
                                size: "30",
                                width: "2",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.staff_Loading
                      ? _c(
                          "v-list",
                          {
                            staticClass: "scroll_content_y",
                            style: {
                              maxHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                48 +
                                "px",
                            },
                            attrs: { dense: "" },
                          },
                          [
                            _c(
                              "v-list-item-group",
                              {
                                attrs: { color: "primary" },
                                model: {
                                  value: _vm.selectOneStaff,
                                  callback: function ($$v) {
                                    _vm.selectOneStaff = $$v
                                  },
                                  expression: "selectOneStaff",
                                },
                              },
                              _vm._l(_vm.show_Staff, function (staff, index) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: "staff---" + index,
                                    staticClass: "pa-0 px-2 ma-0",
                                    attrs: {
                                      dense: "",
                                      "two-line": "",
                                      value: staff.staff_id,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-avatar",
                                      {
                                        staticClass: "pa-0 ma-0 mr-2",
                                        attrs: { size: "36" },
                                      },
                                      [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            size: "36",
                                            src: staff.staff_avatar,
                                            staff_name: staff.preferred_name,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.preferred_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text--secondary text-caption-xs",
                                              },
                                              [_vm._v(_vm._s(staff.staff_code))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.job_post_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-card",
                  {
                    staticClass: "flex-grow-1 ml-3 rounded-lg",
                    class: _vm.draging ? "mrc-border-dashed" : "",
                    attrs: { elevation: "0" },
                    on: { dragover: _vm.fileDragover, drop: _vm.fileDrop },
                  },
                  [
                    _c("Tabler", {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.desserts,
                        showSelect: _vm.showSelect,
                        defaultSelect: _vm.selected,
                        height: _vm.$vuetify.breakpoint.height - 275 - 48,
                        totalCount: _vm.totalCount,
                      },
                      on: {
                        select: _vm.onSelect,
                        change: function (page, perpage, callback) {
                          _vm.getList(
                            _vm.selectOneStaff,
                            page,
                            perpage,
                            callback
                          )
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          _vm.selected.length
                            ? {
                                key: "header.filename",
                                fn: function (ref) {
                                  var header = ref.header
                                  return [
                                    _c(
                                      "v-sheet",
                                      {
                                        staticClass:
                                          "transparent d-flex flex-row align-center",
                                        attrs: { height: "25" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.selected.length) +
                                            _vm._s(
                                              _vm.$t(
                                                "label_table_list_selected_numLabel"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("v-sheet", {
                                          staticClass: "grey fill-height mx-1",
                                          attrs: { width: "1" },
                                        }),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "text-capitalize px-0",
                                            attrs: {
                                              text: "",
                                              color: "primary",
                                              small: "",
                                              ripple: false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toDownLoad(
                                                  _vm.selected
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v(" save_alt ")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_table_list_selected_downloadBtnLabel"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "text-capitalize px-0 ml-2",
                                            attrs: {
                                              text: "",
                                              color: "primary",
                                              small: "",
                                              ripple: false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm
                                                  .$confirmDo(
                                                    _vm.$t(
                                                      "label_essweb_admin_Tax_list_title"
                                                    )
                                                  )
                                                  .then(function (res) {
                                                    res
                                                      ? _vm.toDelete(
                                                          _vm.selected
                                                        )
                                                      : null
                                                  })
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v(" delete ")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_list_components_tools_delBtnLabel"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              }
                            : null,
                          {
                            key: "item.filename",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "\n                d-inline-block\n                text-truncate\n                d-flex\n                align-center\n                transparent\n              ",
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        size: "24",
                                        fill: "#0f46c1",
                                        iconClass:
                                          item.doc_type == "jpg"
                                            ? "filetype-jpg"
                                            : item.doc_type == "csv"
                                            ? "filetype-csv"
                                            : item.doc_type == "doc"
                                            ? "filetype-doc"
                                            : item.doc_type == "gif"
                                            ? "filetype-gif"
                                            : item.doc_type == "png"
                                            ? "filetype-png"
                                            : item.doc_type == "xls"
                                            ? "filetype-xls"
                                            : item.doc_type == "docx"
                                            ? "filetype-doc"
                                            : item.doc_type == "xlsx"
                                            ? "filetype-xls"
                                            : item.doc_type == "pdf"
                                            ? "filetype-pdf"
                                            : item.doc_type == "ppt"
                                            ? "filetype-ppt"
                                            : item.doc_type == "jpeg"
                                            ? "filetype-jpg"
                                            : "filetype-file",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text--primary table-title pa-1",
                                        attrs: {
                                          title: _vm.$getCommonLangValue(
                                            item.doc_title
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                item.doc_title
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.date",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "text--primary table-title" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getDateTime(
                                            item.release_utc_datetime,
                                            "YYYY/MM/DD"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.upload_time",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "text--primary table-title" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getDateTime(
                                            item.upload_utc_datetime,
                                            "YYYY/MM/DD HH:mm"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.size",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "text--primary table-title" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$byteconvert(item.doc_size)
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("tableListTools", {
                                  attrs: {
                                    uuid: item.uuid,
                                    delBtn: _vm.hasBtn("delete-admin-tax-form"),
                                    viewBtn: _vm.hasBtn(
                                      "download-admin-tax-form"
                                    ),
                                    editBtn: _vm.hasBtn("edit-admin-tax-form"),
                                    title: _vm.$t(
                                      "label_essweb_admin_Tax_list_title"
                                    ),
                                    viewText:
                                      "label_essweb_table_list_selected_taxDownloadLabel",
                                  },
                                  on: {
                                    delete: _vm.toDelete,
                                    edit: function ($event) {
                                      return _vm.toEdit(item)
                                    },
                                    view: _vm.toDownLoad,
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("uploadFile", {
              attrs: {
                show: _vm.showUpload,
                staff: _vm.selectWillStaff,
                files: _vm.files,
              },
              on: {
                close: function ($event) {
                  _vm.showUpload = false
                },
                submit: _vm.onSubmit,
              },
            }),
            _c("editFiles", {
              attrs: { propertyData: _vm.propertyData, show: _vm.showEdit },
              on: {
                close: function ($event) {
                  _vm.showEdit = false
                },
                submit: _vm.onEdit,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }